import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const appRoutes: Routes = [
  {
    path: '',
    redirectTo: '/authorization',
    pathMatch: 'full'
  },
  {
    path: 'authorization',
    loadChildren: '../authorization/authorization.module#AuthorizationModule',
    data: { title: 'page.title.authorization' }
  },
  {
    path: 'home',
    loadChildren: '../home-page/home-page.module#HomePageModule',
    data: { title: 'page.title.home' }
  },
  {
    path: 'consolidated_scores',
    loadChildren: '../consolidated-students-scores/consolidated-students-scores.module#ConsolidatedStudentsScoresModule',
    data: { title: 'page.title.consolidated-scores' }
  },
  {
    path: 'student_progress',
    loadChildren: '../student-progress/student-progress.module#StudentProgressModule',
    data: { title: 'page.title.student-progress' }
  },
  {
    path: 'students_list',
    loadChildren: '../student-activity/students-list.module#StudentsListModule',
    data: { title: 'page.title.students-list' }
  },
  {
    path: 'advanced_reporting_filters',
    loadChildren: '../student-activity/advanced-reporting-filters/advanced-reporting-filters.module#AdvancedReportingFiltersModule',
    data: { title: 'page.title.advanced-reporting-filters'  }
  },
  {
    path: 'session_detail_options',
    loadChildren: '../student-activity/session-options.module#SessionOptionsModule',
    data: { title: 'page.title.session-options' }
  },
  {
    path: 'logout',
    loadChildren: '../logout/logout.module#LogoutModule',
    data: { title: 'page.title.logout' }
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule {}
